import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入附件上传页面
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
import RecordDirectlyLogs from "../../../record/contractRecordDirectly/recordDirectlyLogs/index.vue";
export default {
  data() {
    return {
      activeNames: FormConfig.configList().map(item => {
        return item.name;
      }), // 默认展开全部面板
      // 全局加载框
      fullLoading: null,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        originalId: null, // 原始主键
        regulators: null, // 区管代码
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        buildCorp: null, // 建设单位
        corpLegal: null, // 法定代表
        linkMan: null, // 联系人
        linkTel: null, // 联系人电话
        noteNumber: null, // 立项批准文号
        projectSite: null, // 工程地点
        fundsCharacter: null, // 资金性质
        fundsSources: null, // 资金来源及落实情况
        economicType: null, // 公司经济类型
        recordUnitName: null, // 项目核准或备案单位名称
        approvalName: null, // 批文名称
        buildingLandObtained: null, // 建设用地取得方式
        constructionArea: null, // 房屋建筑工程建筑面积
        structuralHierarchy: null, // 结构层次
        municipalProjectScale: null, // 市政工程规模
        otherProjectScale: null, // 其它工程规模
        constructionUnit: null, // 施工单位
        qualificationCategories: null, // 企业资质类别及等级
        projectManager: null, // 项目经理
        qualificationCategoryLevel: null, // 执业资格类别等级及编号
        managerCertificateNumber: null, // 项目经理安全生产考核合格证书编号
        managementCertificateNumber: null, // 专职安全生产管理人员安全生产考核合格证书编号
        planTimeLimit: null, // 计划工期
        projectCost: null, // 工程造价
        contractScope: null, // 发包范围
        state: null, // 状态
        situation: null, // 资金来源落实情况
        remarks: null, // 备注
        constructionUnitName: null, // 施工单位名称
        managementCertificateName: null, // 专职安全生产管理人员
        sealDate: null, // 盖章日期
        tenderClassNum: null, // 招标类别
        tenderContentNum: null, // 招标内容
        processState: null, // 流程状态
        regulatorsName: null, // 区管代码名称
        projectManagerName: null, // 项目经理名称
        tenderClassName: null, // 招标类别名称
        tenderContentName: null, // 招标内容名称
        auditOpinion: null, // 核验意见
        isUnion: null, // 是否允许联合体
        econUnit: null, // 勘察单位
        econUnitName: null, // 勘察单位名称
        econProjectManager: null, // 勘察项目负责人
        econProjectManagerName: null, // 勘察项目经理名称
        designUnit: null, // 设计单位
        designUnitName: null, // 设计单位名称
        designProjectManager: null, // 设计项目负责人
        designProjectManagerName: null, // 设计项目经理名称
        superUnit: null, // 监理单位
        superUnitName: null, // 监理单位名称
        superProjectManager: null, // 监理项目负责人
        superProjectManagerName: null, // 监理项目经理名称
        constructionState: null, // 施工单位确认状态
        constructionSealDate: null, // 施工单位盖章日期
        econState: null, // 勘察单位确认状态
        econSealDate: null, // 勘察单位盖章日期
        designState: null, // 设计单位确认状态
        designSealDate: null, // 设计单位盖章日期
        superState: null, // 监理单位确认状态
        superSealDate: null, // 监理单位盖章日期
        econProjectCost: null, // 勘察工程造价
        designProjectCost: null, // 设计工程造价
        superProjectCost: null, // 监理工程造价
      },
      // 表单错误
      errRules: {},
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 主键
      id: null,
      // 操作类型
      controllerFlg: null,
      // 历史查看标志
      historyType: null,
      // 核验表单
      auditForm: {
        id: null,
        recordNumber: null,
        state: null,
        auditType: null,
        auditContent: null,
        lockNo: null,
        digitalSignature: null,
      },
      /***********************************工程施工单位项目管理机构配备情况*************************************/
      // 加载
      organizationAllocationinfoLoading: false,
      // 表格基础数据
      organizationAllocationinfoTableColumns: [
        {
          label: "职务",
          prop: "duty",
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "职称",
          prop: "positionalTitles",
        },
        {
          label: "证书名称",
          prop: "certificateName",
        },
        {
          label: "级别",
          prop: "level",
        },
        {
          label: "证号",
          prop: "number",
        },
        {
          label: "专业",
          prop: "professional",
        },
      ],
      // 列表数据
      organizationAllocationinfoTableData: [],
      // 分页
      organizationAllocationinfoReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      organizationAllocationinfoTotal: 0,
      /***************************************联合体单位*******************************************/
      unionLoading: false, // 列表loading状态
      // 联合体单位表单
      unionForm:{ },
      // 表格基础数据
      unionTableColumns: [
        {
          label: "联合体单位名称",
          prop: "unionCorpName"
        },
        {
          label: "联合体单位类型",
          prop: "unionUnitTypeName"
        },
        {
          label: "是否同意",
          slotName: "isAgree"
        },
        {
          label: "确认日期",
          prop: "sealDate"
        },
      ],
      // 表格数据
      unionTableData: [],
    };
  },

  // 注册组件
  components: {
    RecordDirectlyLogs,
    TenderPictureinfor // 附件页面
  },
  // 模板编译完成
  mounted() {
    // 获取标识
    this.controllerFlg = this.$route.query.controllerFlg;
    // 获取历史查看标志
    this.historyType = this.$route.query.historyType;
    // 获取主键
    this.auditForm.recordNumber = this.$route.query.id;
    // 核验主键
    this.auditForm.id = this.$route.query.auditId;
    // 核验类型
    this.auditForm.auditType = this.$route.query.auditType;
    // 默认调用
    this.fun_Open();
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
      // 查看详情
      this.fun_GetDetail();
    },
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("/contractRecordDirectly/auditDetail", {
        id: this.auditForm.recordNumber,
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
          // 执行处理页面显示方法
          this.fun_GetHandle();
          // 施工单位项目管理机构配备情况日志表一览
          this.fun_GetOrganizationAllocationList();
          // 获取联合体数据
          this.fun_ContractRecordUnionList();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
        // 加载框取消
        this.fullLoading.close();
      })
    },
    /**
     * 需要处理页面显示逻辑代码
     */
    fun_GetHandle() {
      // 备案状态是1解除合同或者2申请解除中,
      if(this.form.recordState == "1" || this.form.recordState == "2"){
        // 是否存在
        let rtn = false;
        // 遍历查询表单
        this.formConfigList.map((item, num) => {
          // 如果是解除合同文件扫描件
          if (item.title === "解除合同文件扫描件") {
            // 设置为存在
            rtn = true;
          }
        });
        // 如果不存在
        if (!rtn) {
          // 删除
          this.formConfigList.splice(1, 0, {
            title: "解除合同文件扫描件",
            name: "2",
            icon: "",
            formConfigList: [
              {
                label: "解除合同文件扫描件：",
                slotName: "uploadFile",
              }
            ]
          });
        }
      }
      // 如果不是联合体
      if(this.form.isUnion != "1"){
        // 遍历查询表单
        this.formConfigList.map((item, num) => {
          // 如果是联合体单位信息
          if (item.title === "联合体单位信息") {
            // 删除
            this.formConfigList.splice(num, 1);
          }
        });
        // 遍历查询表单
        this.formConfigList.map((item, num) => {
          // 如果是联合体协议扫描件
          if (item.title === "联合体协议扫描件") {
            // 删除
            this.formConfigList.splice(num, 1);
          }
        });
      }
      // 默认展开全部面板
      this.activeNames = this.formConfigList.map(item => {
        return item.name;
      });
    },
    /**
     * 联合体单位集合
     */
    fun_ContractRecordUnionList(){
      // 主键不为空
      if(this.auditForm.recordNumber){
        // 打开loading
        this.unionLoading = true;
        // 发起请求
        fun_PostAction("/contractRecordDirectly/unionList", {
          recordDirectlyId: this.auditForm.recordNumber,
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // 联合体列表数据
            this.unionTableData = data;
          }
          // 关闭加载
          this.unionLoading = false;
        });
      }
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetOrganizationAllocationList() {
      // 打开loading
      this.organizationAllocationinfoLoading = true;
      // 发起请求
      fun_PostAction("/organizationAllocation/list", {
        ...this.organizationAllocationinfoReqPageData,
        contractRecordDirectlyId: this.auditForm.recordNumber,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.organizationAllocationinfoTableData = records;
          // 获取分页总条数
          this.organizationAllocationinfoTotal = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.organizationAllocationinfoLoading = false;
      })
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_OrganizationLogsLimitChange(e) {
      // 获取每页显示条数
      this.organizationAllocationinfoReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetOrganizationAllocationList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_OrganizationLogsPageChange(e) {
      // 获取当前页码
      this.organizationAllocationinfoReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetOrganizationAllocationList();
    },
    /**
     * 直接发包备案记录
     */
    fun_OpenRecordDirectlyLogsDialog(){
      // 打开弹窗
      this.$refs.recordDirectlyLogs.dialogVisible = true;
      // 设置直接发包备案主键
      this.$refs.recordDirectlyLogs.originalId = this.form.id;
      // 请求接口
      this.$refs.recordDirectlyLogs.fun_GetList();
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading() {
      this.fullLoading = this.$loading({
        lock: true,
        text: "正在进行加载，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
       // 赋值
       this.form[i] = e;
    },
    /**
    * 提交方法
    * @author liutong
    */
    fun_Audit(state) {
      // 如果状态是退回
      if(state == "th"){
        // 如果核验意见为空
        if(!this.form.auditOpinion){
          // 提示
          this.$alert("核验意见不能为空！", "warning");
          return;
        }
      }
      // 状态
      this.auditForm.state = state;
      // 提交的方法
      this.fun_Submit();
    },
    /**
     * 核验操做
     */
    fun_Submit() {
      // 提示
      let msg = this.auditForm.state === "tg" ? "通过" : "退回";
      // 弹出询问confirm
      this.$confirm("是否确定核验" + msg + "？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 打开遮罩
        this.fun_Loading();
        // 核验意见
        this.auditForm.auditContent = this.form.auditOpinion;
        // 发起请求
        fun_PostAction("/auditProcess/audit", this.auditForm).then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.$router.back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
        });
      }).catch(err => {
        console.log(err);
      })
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor(e) {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹窗
      this.$refs.tenderPictureinfor.type = e;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
  }
};
